import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50 flex flex-col items-center justify-center px-4">
      <div className="text-center">
        <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-background-200 flex items-center justify-center">
          <i className="ri-emotion-sad-line text-4xl text-foreground-500"></i>
        </div>
        <h1 className="text-4xl md:text-5xl font-bold text-foreground-100 font-heading mb-2">404</h1>
        <p className="text-lg text-foreground-400 mb-8">页面找不到了，可能是搬家啦~</p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white rounded-full text-sm font-semibold transition-all whitespace-nowrap"
        >
          <i className="ri-home-line"></i>返回首页
        </Link>
      </div>
    </div>
  );
}